import { render, staticRenderFns } from "./CreateFrom.vue?vue&type=template&id=2a22481b"
import script from "./CreateFrom.vue?vue&type=script&lang=js"
export * from "./CreateFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports